import defaultPrimary from '../default/primary';

const primary = (params) => defaultPrimary(params);

export default primary;
